import { useEffect } from 'react';

interface UseAuthPostMessageProps {
  handler: (event: MessageEvent) => void;
}

export const useAuthPostMessage = ({
  handler
}: UseAuthPostMessageProps): null => {
  useEffect(() => {
    const handleEvent = (event: MessageEvent) => handler(event);

    window.addEventListener('message', handleEvent);
    return () => window.removeEventListener('message', handleEvent);
  }, []);

  return null;
};
